var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Route, Home, Vehicle, Mile, Service, Energy } from 'icons';
import { minutesToHHMM } from 'utils/minutesToHHMM';
var Stats = function (_a) {
    var items = _a.items;
    var keys = {
        'total_routes': 'Routes',
        'total_appointments': 'Homes',
        'total_drive_miles': 'Miles',
        'total_drive_time_minutes': 'Drive',
        'total_service_time_minutes': 'Service',
        'appointments_per_gallon': 'Appts/Gal'
    };
    var calculateDiff = function (type, plan, actual) {
        var diff = '';
        diff = (Math.round(actual * 100 - plan * 100) / 100).toString();
        if (type === 'Drive' || type === 'Service') {
            diff = "".concat(Number(diff) > 0 ? '' : '-').concat(minutesToHHMM(Math.abs(Number(diff))));
        }
        var positive = false;
        if (type === 'Drive' || type === 'Miles' || type === 'Service') {
            if (diff.charAt(0) === '-') {
                positive = true;
            }
            else {
                diff = "+".concat(diff);
            }
        }
        else {
            if (diff.charAt(0) !== '-') {
                positive = true;
                diff = "+".concat(diff);
            }
        }
        if (plan === actual)
            return (_jsx("div", __assign({ className: "bg-[#F9FAFB] rounded p-4 text-right" }, { children: _jsx("span", __assign({ className: "text-black font-inter font-bold text-[15px] leading-5" }, { children: "---" })) })));
        else
            return (_jsx("div", __assign({ className: (positive ? 'bg-[#78C985]' : 'bg-[#F05252]') + ' rounded p-4 text-right' }, { children: _jsx("span", __assign({ className: "text-white font-inter font-bold text-[15px] leading-5" }, { children: diff })) })));
    };
    return (_jsx("div", __assign({ className: "flex grow h-0 p-4 overflow-hidden" }, { children: _jsxs("div", __assign({ className: "overflow-auto flex flex-col gap-2 px-[5.5px] w-full rounded" }, { children: [_jsxs("div", __assign({ className: "flex items-center justify-between" }, { children: [_jsx("div", { className: "w-[60px]" }), ['plan', 'actual', 'diff'].map(function (key) { return (_jsx("div", __assign({ className: "w-[80px] text-center" }, { children: _jsx("span", __assign({ className: "text-[#4B5563] font-inter text-[12px] leading-4" }, { children: key.charAt(0).toUpperCase() + key.slice(1) })) }), key)); })] })), items && Object.keys(keys).map(function (key, index) { return (_jsxs("div", __assign({ className: "flex items-center justify-between", "data-testid": "item_".concat(index) }, { children: [_jsxs("div", __assign({ className: "flex flex-col items-center gap-1 w-[60px]" }, { children: [keys[key] === 'Routes' && _jsx(Route, {}), keys[key] === 'Homes' && _jsx(Home, {}), keys[key] === 'Miles' && _jsx(Mile, {}), keys[key] === 'Drive' && _jsx(Vehicle, {}), keys[key] === 'Service' && _jsx(Service, {}), keys[key] === 'Appts/Gal' && _jsx(Energy, {}), _jsx("span", __assign({ className: "text-[#9CA3AF] font-inter font-bold text-xs leading-[14px]" }, { children: keys[key] }))] })), _jsx("div", __assign({ className: "w-[80px]" }, { children: _jsx("span", __assign({ className: "bg-[#F9FAFB] block text-right text-[#4B5563] font-inter font-bold text-[15px] leading-5 p-4 rounded" }, { children: ['Drive', 'Service'].includes(keys[key]) ? minutesToHHMM(items[key]) : items[key] })) })), _jsx("div", __assign({ className: "w-[80px]" }, { children: _jsx("span", __assign({ className: "bg-[#F9FAFB] block text-right text-[#4B5563] font-inter font-bold text-[15px] leading-5 p-4 rounded" }, { children: ['Drive', 'Service'].includes(keys[key]) ? minutesToHHMM(items["".concat(key, "_actual")]) : items["".concat(key, "_actual")] })) })), _jsx("div", __assign({ className: "w-[80px]" }, { children: calculateDiff(keys[key], items[key], items["".concat(key, "_actual")]) }))] }), key)); })] })) })));
};
export default Stats;
